import { createVNode as _createVNode } from "vue";
import { IconWrapper } from '../runtime';
export default IconWrapper('goblet-one', true, function (props) {
  return _createVNode("svg", {
    "width": props.size,
    "height": props.size,
    "viewBox": "0 0 48 48",
    "fill": "none"
  }, [_createVNode("g", {
    "clip-path": 'url(#' + props.id + '056edbbe' + ')'
  }, [_createVNode("path", {
    "d": "M5.73657 24.1212L10.6863 29.071C15.7632 34.1478 23.9943 34.1478 29.0711 29.071V29.071C34.1479 23.9942 34.1479 15.763 29.0711 10.6862L24.1213 5.73647",
    "stroke": props.colors[0],
    "stroke-width": props.strokeWidth,
    "stroke-linecap": props.strokeLinecap,
    "stroke-linejoin": props.strokeLinejoin
  }, null), _createVNode("path", {
    "d": "M30.0002 29.9999L36 36",
    "stroke": props.colors[0],
    "stroke-width": props.strokeWidth,
    "stroke-miterlimit": "2",
    "stroke-linecap": props.strokeLinecap,
    "stroke-linejoin": props.strokeLinejoin
  }, null), _createVNode("ellipse", {
    "cx": "14",
    "cy": "13.9999",
    "rx": "13",
    "ry": "7",
    "transform": "rotate(-45 14 13.9999)",
    "stroke": props.colors[0],
    "stroke-width": props.strokeWidth
  }, null), _createVNode("ellipse", {
    "cx": "38.0002",
    "cy": "37.9999",
    "rx": "6",
    "ry": "3",
    "transform": "rotate(-45 38.0002 37.9999)",
    "stroke": props.colors[0],
    "stroke-width": props.strokeWidth
  }, null)]), _createVNode("defs", null, [_createVNode("clipPath", {
    "id": props.id + '056edbbe'
  }, [_createVNode("rect", {
    "width": "48",
    "height": "48",
    "fill": props.colors[2]
  }, null)])])]);
});